<template>
  <div class="filter-wrap">
    <ul ref="navBar" class="search-filter-bar">
      <li class="all" @click="switchAllSort">
        <span
          :class="{ 'integrated-selected': allSort, ...themeAppColorClass }"
          class="all-text"
          >{{ class2Name }}</span
        >
        <div class="tag all-tag">
          <img v-show="allSort && allUp" :src="fileterAllUpImg" />
          <img v-show="allSort && allDown" :src="fileterAllDownImg" />
          <img
            v-show="!allSort && allUp"
            src="@/images/activity_goods/all_up.png"
          />
          <img
            v-show="!allSort && allDown"
            src="@/images/activity_goods/all_down.png"
          />
        </div>
      </li>
      <li class="price" @click="switchPriceSort">
        <span :class="{ 'price-selected': priceSort, ...themeAppColorClass }"
          >价格</span
        >
        <div class="tag price-tag">
          <img v-show="priceSort && increment" :src="fileterUpImg" alt="" />
          <img
            v-show="decrement"
            src="@/images/activity_goods/up-nor.png"
            alt=""
          />
          <img v-show="priceSort && decrement" :src="fileterDownImg" alt="" />
          <img
            v-show="increment"
            src="@/images/activity_goods/d-nor.png"
            alt=""
          />
        </div>
      </li>
      <li class="filter" @click="switchFilter">
        <span :class="{ 'instock-selected': filterSort, ...themeAppColorClass }"
          >筛选</span
        >
        <div class="tag filer-tag">
          <img v-if="filterSort" :src="fileterActiveImg" />
          <img v-else src="@/images/activity_goods/filter.png" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import themeMixin from '@/common/mixins/theme'
import {
  fileterAllDownImg,
  fileterAllUpImg,
  fileterDownImg,
  fileterActiveImg,
  fileterUpImg
} from '@/defines/environment/config'
export default {
  name: 'SearchFilterBar',
  mixins: [themeMixin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['decrement', 'allDown', 'allUp', 'priceSort', 'allSort', 'increment'],
  data() {
    return {
      fileterAllDownImg,
      fileterAllUpImg,
      fileterDownImg,
      fileterActiveImg,
      fileterUpImg
    }
  },
  computed: {
    ...mapState('pop', {
      class2Name: state => state.class2Name,
      queryData: state => state.queryData,
      filterSort: state => state.filterSort,
      clearStateData: state => state.clearStateData
    })
  },
  methods: {
    ...mapActions('pop', [
      'openFilter',
      'setActQueryData',
      'getActivitySkuList'
    ]),
    switchAllSort() {
      this.$emit('update:allUp', true)
      this.$emit('update:isShowMask', true)
      this.$emit('update:allDown', false)
    },
    switchPriceSort() {
      this.$emit('update:priceSort', true)
      const flag = !this.decrement
      this.$emit('update:decrement', flag)
      this.$emit('update:increment', !flag)
      this.closeMask()
      const sortType = flag ? 2 : 1
      this.setQueryData('sortType', sortType)
      this.setQueryData('page', 1)
      this.getActivitySkuList(this.queryData)
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    switchFilter() {
      this.closeMask()
      this.openFilter()
    },
    closeMask() {
      this.$emit('update:isShowMask', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-filter-bar {
  display: flex;

  height: 0.98rem;

  justify-content: space-between;

  white-space: nowrap;

  li {
    display: flex;

    align-items: center;

    font-size: 0.28rem;
    font-weight: 700;
    color: #333333;

    &.all,
    &.filter {
      width: 2.16rem;

      justify-content: center;
    }
    .all-text {
      display: inline-block;

      max-width: 1.6rem;
      overflow: hidden;

      text-overflow: ellipsis;
    }
  }
}
.price-selected,
.instock-selected,
.integrated-selected {
  color: #0daf52;
  &.small {
    color: $theme-main_small;
  }
}
.tag {
  display: flex;

  margin-left: 3px;
  &.all-tag {
    img {
      height: 0.06rem;
    }
  }
  &.price-tag {
    width: 0.1rem;
    height: 0.16rem;

    flex-direction: column;
    justify-content: space-between;

    img {
      width: 0.1rem;
      height: 3px;
    }
  }
  &.filer-tag {
    img {
      height: 0.2rem;
    }
  }
}
.filter-wrap {
  width: 100%;

  flex: none;
}
</style>
